export interface CreateProjectCommitteesInput {
  projectId: string;
  committees: ProjectCommitteeInput[];
}

export interface ProjectCommitteeInput {
  category: string;
  collaborationName: string;
  description: string;
  url: string;
}
